var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardCustomize(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dashboard_customize_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4437",
    "data-name": "Path 4437",
    className: "cls-1",
    d: "M0,0H24V24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4438",
    "data-name": "Path 4438",
    d: "M3,3h8v8H3ZM13,3h8v8H13ZM3,13h8v8H3Zm15,0H16v3H13v2h3v3h2V18h3V16H18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCustomize);
export default __webpack_public_path__ + "static/media/dashboard-customize.b9d980874a8aaa258e7e27648b42142e.svg";
export { ForwardRef as ReactComponent };